<template>
    <div :class="{page:!isLoading && pageCode === 1}">
        <VanEmpty v-if="isLoading" image="network" description="努力加载中..."/>
        <VanEmpty v-else-if="pageCode === 0" :description="description" @click.native="login">
            <VanButton v-if="showAuthButton" round type="primary" class="empty-button" @click.native="login">授权登录</VanButton>
        </VanEmpty>
        <VanEmpty v-else-if="pageCode === -1" image="error" description="请求失败，请点击这里重试" @click.native="reload">
            <VanButton round type="primary" class="empty-button" @click.native="reload">重新加载</VanButton>
        </VanEmpty>
        <slot v-else/>
    </div>
</template>

<script>
    import Utils from '@/utils';

    let authTimeout = null;

    export default {
        name: 'Page',
        props: {
            pageCode: {
                type: Number,
                default: 1,
            },
            isLoading: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                showAuthButton: false,
                description: '授权登录中...',
            };
        },
        watch: {
            pageCode(val) {
                if (val === 0) {
                    clearTimeout(authTimeout);
                    authTimeout = setTimeout(() => {
                        this.description = Utils.env.isWxBrowser() ? '正在授权，请点击允许按扭' : '正在授权，请点击同意按扭';
                        this.showAuthButton = false;
                        clearTimeout(authTimeout);
                        authTimeout = setTimeout(() => {
                            this.description = '需要您授权登录才能继续访问';
                            this.showAuthButton = true;
                        }, 5000);
                    }, 1000);
                }
            },
        },
        methods: {
            reload() {
                this.$emit('reload');
            },
            login() {
                Utils.env.login();
            },
        },
    };
</script>

<style lang="less" scoped>
.empty-button {
    width: 10em;
}
</style>
